import React from 'react';
import './XPressId.scss';
import { useXpressIdEvents } from './hooks/useXpressIdEvents';
import { useXpressIdIframe } from 'components/shared/XpressId/hooks/useXpressIdIframe';
import { withHandlersTagging } from 'components/shared/XpressId/hocs/withHandlersTagging';
import { withHandlersServerLogging } from 'components/shared/XpressId/hocs/withHandlersServerLogging';
import { isDesktop } from 'utilities/browser';
import { formatText } from 'core/i18n';

export const XpressId = withHandlersServerLogging(
    withHandlersTagging(({ accessToken, onProcessCompleted, onProcessCancelled, onProcessError, onProcessEvents }) => {
        const { iframeRef, src, isLoading, handleIframeLoad } = useXpressIdIframe(accessToken);

        useXpressIdEvents({
            onProcessCompleted,
            onProcessCancelled,
            onProcessError,
            onProcessEvents,
        });

        return (
            <div className={`xpress-id-container ${isDesktop() ? 'xpress-id-qr-min-height' : ''}`}>
                {isLoading && <div className="center-loader">{formatText('videoselfie-loadingCapturer')}</div>}
                {accessToken && (
                    <iframe
                        ref={iframeRef}
                        title="veridas-xpress-id"
                        allow="camera; microphone; geolocation;"
                        src={src}
                        onLoad={handleIframeLoad}
                    />
                )}
            </div>
        );
    }, true)
);
